import { render, staticRenderFns } from "./RecentlyActivity.vue?vue&type=template&id=41bf6be5&scoped=true"
import script from "./RecentlyActivity.vue?vue&type=script&lang=js"
export * from "./RecentlyActivity.vue?vue&type=script&lang=js"
import style0 from "./RecentlyActivity.vue?vue&type=style&index=0&id=41bf6be5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bf6be5",
  null
  
)

export default component.exports